const { navBarIsHidden, setHiddenNavBodyClass } = require('@/lib/Dom/domFunctions');

/**
 * @constructor
 *
 * @param $location
 * @param $rootScope
 * @param $timeout
 * @param {UserService} userService
 */
const NavigationService = function (
    $location,
    $rootScope,
    $timeout,
    userService
) {
    this.$location = $location;
    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.userService = userService;
};

NavigationService.prototype = {
    /**
     * @return {string}
     */
    getCurrentPath() {
        return this.$location.path();
    },

    showNav() {
        setHiddenNavBodyClass(false);
    },

    hideNav() {
        setHiddenNavBodyClass(true);
    },

    toggleNav() {
        if (navBarIsHidden()) {
            this.showNav();
        } else {
            this.hideNav();
        }
    },

    /**
     * Go to the 403 (no permission) page.
     */
    view403() {
        this.goToPath('/403', true);
    },

    viewEposIndex() {
        this.goToPath('/', false);
    },

    viewAccounts() {
        this.goToPath('/accounts');
    },

    /**
     * If the customer account refs are back-filled in the DB, ref could be used in the URL instead of ID.
     *
     * @param {number} accountId
     */
    viewAccountDetails(accountId) {
        this.goToPath('/accounts/' + accountId, true);
    },

    /**
     * Go to login screen.
     */
    viewLogin() {
        this.goToPath('/login', true);
    },

    /**
     * Go to device selection.
     */
    viewDevice() {
        this.goToPath('/device', true);
    },

    /**
     * @param {string} membershipRef
     * @param {string|null} [memberRef]
     * @param {boolean|null} [fromRedeem] Is the user coming from the redeem screen?
     */
    viewMembershipDetails(membershipRef, memberRef, fromRedeem) {
        let path = '/memberships/' + membershipRef;
        let params = {};
        if (memberRef) {
            path = path + '/' + memberRef;
        }
        if (fromRedeem) {
            params = { fromRedeem };
        }

        this.goToPath(path, true, params);
    },

    /**
     * Go to the redemption / order search screen.
     */
    viewRedeem() {
        this.goToPath('/orders', true);
    },

    /**
     * @param {string} scannedBarcode
     */
    viewRedeemWithScannedBarcode(scannedBarcode) {
        this.goToPath('/orders', true, { scannedBarcode });
    },

    /**
     * @param {string} bookingRef
     * @param {boolean|null} [wasBarcodeScan]
     * @param {{}} queryParams
     */
    viewOrderDetails(bookingRef, wasBarcodeScan, queryParams = {}) {
        wasBarcodeScan = !!wasBarcodeScan;
        this.goToPath('/orders/' + bookingRef + '/' + wasBarcodeScan, true, queryParams);
    },

    /**
     * Go to sell screen.
     */
    viewSell() {
        this.goToPath('/sell', true);
    },

    viewReports() {
        this.goToPath('/report', true);
    },

    viewDojoReports() {
        this.goToPath('/dojo-reports', true);
    },

    /**
     * @param {string} path
     * @param {boolean|null} showNav
     * @param {object} queryParams
     */
    goToPath(path, showNav = null, queryParams = {}) {
        // This uses $timeout because if you click a button in Vue, Angular will take a long
        // time to respond.
        this.$timeout(() => {
            if (showNav === true) {
                this.showNav();
            } else if (showNav === false) {
                this.hideNav();
            }

            this.$location.path(path).search(queryParams);
        });
    },

    /**
     * @param {AppPath} appPath
     */
    goToAppPath(appPath) {
        this.goToPath(
            appPath.path,
            null,
            appPath.params || {}
        );
    },

    /**
     * @param {string} requestedPath
     * @return {boolean}
     */
    isNavigationAllowed(requestedPath) {
        if (this.$rootScope.appReady) {
            return true;
        }

        let allowedPaths = [
            '',
            '/',
        ];

        if (this.userService.isLoggedIn()) {
            allowedPaths.push('/device');
        } else {
            allowedPaths.push('/login');
        }

        if (allowedPaths.indexOf(requestedPath) === -1) {
            console.log('App is not ready. Preventing navigation to', requestedPath);
            return false;
        }
        console.log('App is not ready. But allowing navigation to allowed path', requestedPath);
        return true;
    },
};

module.exports = NavigationService;
